import { useCloseRaffleMutation, useGetPurchaseOrdersQuery } from "../../store/api";
import { Box, Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { PurchaseOrderTable } from "../puchaseOrder/table";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { PURCHASE_ORDER_STATUS_V2 } from "../../constants/purchaseOrderStatus";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { Close } from "@mui/icons-material";

export const PurchaseOrderPage = () => {
  
  const selectedRaffle = useAppSelector(
    ({ selectedRaffle }: RootState) => selectedRaffle,
  );
  
  const userLoggedProfile = useAppSelector(
    ({ user }: RootState) => user.profile,
  );

  const { data: purchaseOrders, refetch } = useGetPurchaseOrdersQuery(selectedRaffle.id, {
    skip: selectedRaffle.id === 'default',
  });

  const purchaseOrdersByStatus = (selectedRaffle.accountId === 'agudojhonny'
    ? PURCHASE_ORDER_STATUS_V2.filter(pos => pos.id !== 'TRANSFER_PAYMENT_CREATED')
    : PURCHASE_ORDER_STATUS_V2).map((statusInfo) => {
    const orders = purchaseOrders?.filter((po) => po.status === statusInfo.id) || [];
    const ticketsCount = orders.reduce((acc, o) => acc + (o.ticketQuantity ?? 0), 0);
      return {
        ...statusInfo,
        count: orders.length,
        ticketsCount
      };
    });

    const [closeRaffleHandler] = useCloseRaffleMutation();
    const handleCloseRaffle = async () => {
        try {
          const result = await closeRaffleHandler({
            conf: {
              sendEmail: false,
              winnerEmail: "",
            },
            raffleId: selectedRaffle.id,
          }).unwrap();
    
          if (result) {
            enqueueSnackbar("Rifa cerrada con éxito!", {
              variant: "success",
              anchorOrigin: { horizontal: "right", vertical: "top" },
            });
            setTimeout(() => window.location.reload(), 1500);
          } else {
            enqueueSnackbar("Error al cerrar la rifa", {
              variant: "error",
              anchorOrigin: { horizontal: "right", vertical: "top" },
            });
          }
        } catch {
          enqueueSnackbar("Error al cerrar la rifa", {
            variant: "error",
            anchorOrigin: { horizontal: "right", vertical: "top" },
          });
        }
      };

  const isMobileView = useIsMobileView();
  const [open, setOpen] = useState(false);


    const handleClose = () => {
      setOpen(false);
    };
   
  const finishedTickets =
  (purchaseOrdersByStatus.find(pos => pos.id === 'PROCESS_FINISHED')?.ticketsCount ?? 0) +
  (purchaseOrdersByStatus.find(pos => pos.id === 'SENDING_MAIL_ERROR')?.ticketsCount ?? 0) +
  (purchaseOrdersByStatus.find(pos => pos.id === 'TRANSFER_PAYMENT_CREATED')?.ticketsCount ?? 0);

  const porcentaje = 10000 > 0 ? ((finishedTickets / 10000) * 100).toFixed(2) : '0';

  return (
    <Box paddingX={isMobileView ? 2 : 10} marginTop={2}>
      <Typography variant="h6" fontFamily={"Georgia"} paddingBottom={2} >
        Ordenes de compra
      </Typography>
      <Box display="grid" gridTemplateColumns={isMobileView ? '1fr 1fr' : 'repeat(5, 1fr)'} gap={2} marginBottom={4}>
        { userLoggedProfile == 'admin' && purchaseOrdersByStatus.map((status) => (
          <Card key={status.id} variant="outlined" sx={{ borderRadius: 2, minHeight: 100 }}>
            <CardContent sx={{ padding: 1.5 }}>
              <Typography variant="body2" fontWeight="bold" color="text.primary">
                {status.title}
              </Typography>
              <Typography variant="h6" fontWeight="medium" color="primary" mt={0.5}>
                {status.count} {userLoggedProfile == 'admin' && <Chip label={`${status.ticketsCount} tickets`} />}
              </Typography>
              {status.description && (
                <Typography variant="caption" color="text.secondary">
                  {status.description}
                </Typography>
              )}
            </CardContent>
          </Card>
        ))}
       <Dialog open={open} onClose={handleClose} fullScreen={isMobileView}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>

        <DialogTitle
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '1.25rem',
            mt: 2,
          }}
        >
          ¿Está seguro que desea cerrar la rifa?
        </DialogTitle>

        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            px={2}
            py={3}
          >
            <Typography variant="body1" mb={1}>
              Proyección de venta estimada:
            </Typography>
            <Typography
              variant="h3"
              fontWeight="bold"
              color="primary"
              mb={2}
              sx={{
                fontSize: isMobileView ? '2.5rem' : '3rem',
              }}
            >
              {porcentaje}%
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Puede seguir confirmando tickets despues de cerrrar la rifa. Puedes volver a activar la rifa desde el dashboard.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            size="medium"
            onClick={handleCloseRaffle}
          >
            Confirmar cierre
          </Button>
        </DialogActions>
      </Dialog>

        {userLoggedProfile == 'admin' && <Card variant="outlined" sx={{ borderRadius: 2, minHeight: 100 }}>
            <CardContent sx={{ padding: 1.5 }}>
              <Typography variant="body2" fontWeight="bold" color="text.primary">
                % venta proyectada
              </Typography>
              <Typography variant="h6" fontWeight="medium" color="primary" mt={0.5}>
                <Typography variant="h6" fontWeight="medium" color="primary" mt={0.5}>
                  {porcentaje}%
                </Typography>
              </Typography>
              <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="body2" color="text.secondary">
                  ¿Desea cerrar la rifa?
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  disabled={Number.parseFloat(porcentaje) < 90}
                  onClick={() => setOpen(true)}
                  >
                  Cerrar rifa
                </Button>
              </Box>
            </CardContent>
          </Card>}
          
      </Box>
      {purchaseOrders ? <PurchaseOrderTable purchaseOrders={purchaseOrders} selectedRaffle={selectedRaffle} refetch={refetch} /> : null}
    </Box>
  );
};
